<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.pt-8.pb-0
      .d-flex.justify-center
        v-container.pa-8(fluid style="width:1600px")
          .text-xl.neutral700--text.font-semibold.mb-4 {{ parentId ? 'Edit' : 'New' }} list

          v-card.pa-6.mb-6.rounded-lg(outlined)
            .text-md.font-semibold.mb-4 List information
            v-row(no-gutters)
              v-col
                .text-sm.font-semibold.neutral700--text List name*
                v-text-field.text-sm.mt-2.round-xl(v-model="name" placeholder="Enter list name" outlined dense height="48" hide-details="auto" :rules="rules.not_empty" :disabled="selectedInventory.isFetching")
              v-col.mx-4
                .text-sm.font-semibold.neutral700--text Order frequency (optional)
                v-select.mt-2.text-sm.round-xl(v-model="orderFrequency" height="48" placeholder="Select frequency" :items="orderFrequencyOptions" outlined dense clearable :disabled="selectedInventory.isFetching")
              v-col
                .text-sm.font-semibold.neutral700--text Remarks (optional)
                v-text-field.text-sm.mt-2.round-xl(v-model="remarks" placeholder="Enter remark" outlined dense height="48" hide-details="auto" :disabled="selectedInventory.isFetching")
          
          v-card.pa-6.mb-6.rounded-lg(outlined)
            .d-flex.justify-space-between.align-center.mb-4
              .text-md.font-semibold Add item to your list
              v-btn.button-sm.neutral700.white--text(depressed @click="openAddItemToListDialog = true") Add item
            v-data-table.mt-4.pb-6(v-model="selected" :headers="headers" :items="selectedInventory.data" item-key="id" :items-per-page="-1" :loading="selectedInventory.isFetching" hide-default-footer loader-height="2" disable-sort)
              template(v-slot:header.data-table-select="{ props }")
                yc-checkbox(:input-value="allSelected" :indeterminate="props.indeterminate" :disabled="selectedInventory.data.length === 0" @change="handleSelectAll")
              template(v-slot:item.data-table-select="{ item, select, isSelected }")
                yc-checkbox(:input-value="isSelected" :disabled="item.disabled" @change="select($event)")
              template(v-slot:item.price="{ item }")
                .text-sm {{ item.cost | displayPrice }}
              template(v-slot:item.usage="{ item }")
                v-row.my-2(no-gutters)
                  v-col
                    .text-sm {{ item.usage['7_days'] }}
                    .text-xs.neutral500--text 7 days
                  v-col
                    v-divider.mx-2(vertical)
                  v-col
                    .text-sm {{ item.usage['14_days'] }}
                    .text-xs.neutral500--text 14 days
                  v-col
                    v-divider.mx-2(vertical)
                  v-col
                    .text-sm {{ item.usage['30_days'] }}
                    .text-xs.neutral500--text 30 days
              template(v-slot:item.action="{ item }")
                v-btn.button-xs(icon @click="handleRemoveItem(item)")
                  v-icon $yzi-trash-03
              template(v-slot:no-data)
                v-card.px-4.py-8.my-8.border-dashed(outlined)
                  .d-flex.flex-column.align-center.justify-center
                    v-icon.mb-6(size="30") $yzi-colors
                    .text-md.font-semibold.mb-1 You do not have any item selected yet
                    .text-sm.neutral500--text Start adding item by clicking the “Add item” button at top right corner. Added item will be shown here

    v-card-actions.white.pa-0
      .d-flex.flex-column(style="width:100%")
        v-divider
        .d-flex.align-center.pa-4.justify-end
          v-btn.button-md.neutral700--text.underline.mr-2(text :disabled="isLoading" @click="handleCloseDialog") Cancel
          v-btn.button-md(:loading="isLoading" color="primary" depressed :disabled="!canProceed" @click="handleSave") Save list
  .dialogs
    add-item-to-list-dialog(v-if="openAddItemToListDialog" :open.sync="openAddItemToListDialog" :overrideCompanySlug="overrideCompanySlug" @added="handleAddItemToList")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddItemToListDialog from '@/components/clinic/dialogs/purchasehub/AddItemToListDialog.vue'

export default {
  components: {
    AddItemToListDialog,
  },
  props: {
    open: {
      type: Boolean,
    },
    parentId: {
      type: Number,
      default: null
    },
    overrideCompanySlug: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      name: null,
      orderFrequency: null,
      orderFrequencyOptions: [
        { text: 'Weekly', value: 'weekly' },
        { text: 'Bi-Weekly', value: 'bi-weekly' },
        { text: 'Monthly', value: 'monthly' },
        { text: 'Quarterly', value: 'quarterly' },
        { text: 'Yearly', value: 'yearly' },
        { text: 'As needed', value: 'as needed' },
      ],
      remarks: null,
      selected: [],
      headers: [
        { text: '#', value: 'no' },
        { text: 'Item', value: 'name', width: '400px' },
        { text: 'Cost price', value: 'price' },
        { text: 'Stock', value: 'inventory_qty' },
        { text: 'Usage', value: 'usage' },
        { text: '', value: 'action' },
      ],
      selectedInventory: {
        data: [],
        isFetching: false,
        isError: false,
        totalCount: 0
      },
      isLoading: false,
      openAddItemToListDialog: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      }
    }
  },
  mounted () {
    if (this.parentId) {
      this.fetchInventoryItems()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    payload () {
      return {
        name: this.name,
        order_freq: this.orderFrequency,
        remarks: this.remarks,
        products: this.selectedInventory.data.map(item => item.id)
      }
    },
    companySlugToUse () {
      return this.overrideCompanySlug || this.company.slug
    },
    canProceed () {
      return this.name && this.selectedInventory.data.length > 0
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleRemoveItem (item) {
      this.selectedInventory.data = this.selectedInventory.data.filter(inventory => inventory.id !== item.id)
      this.handleUpdateData()
    },
    handleCloseDialog () {
      this.$emit('close')
      this.showDialog = false
    },
    handleAddItemToList (items) {
      this.selectedInventory.data = [...this.selectedInventory.data, ...items]
      this.handleUpdateData()
      this.selectedInventory.totalCount = this.selectedInventory.data.length
      this.openAddItemToListDialog = false
    },
    handleUpdateData () {
      this.selectedInventory.data = this.selectedInventory.data.map((item, idx) => this.sanitizeData(item, idx))
    },
    sanitizeData (item, idx) {
      return {
        ...item,
        no: idx + 1,
      }
    },
    async fetchInventoryItems () {
      this.selectedInventory.isFetching = true
      try {
        const { data } = await this.axios.get(`/clinics/${this.companySlugToUse}/inventory_lists/${this.parentId}/items`, {
          params: {
            page_size: -1
          }
        })
        this.name = data.meta.name
        this.orderFrequency = data.meta.order_freq
        this.remarks = data.meta.remarks
        if (data.count > 0) {
          this.selectedInventory.data = data.results.map((item, idx) => this.sanitizeData(item, idx))
          this.selectedInventory.totalCount = data.count
        }
      } catch (error) {
        this.selectedInventory.isError = true
      } finally {
        this.selectedInventory.isFetching = false
      }
    },
    async handleSave () {
      try {
        this.isLoading = true
        if (this.parentId) {
          const endpoint = `/clinics/${this.companySlugToUse}/inventory_lists/${this.parentId}`
          const resp = await this.axios.patch(endpoint, this.payload)
          this.showMessage(['success', 'List successfully updated'])
          this.updateActivityLog(endpoint, this.payload, resp, 'PATCH', this.parentId)
        } else {
          const endpoint = `/clinics/${this.companySlugToUse}/inventory_lists`
          const resp = await this.axios.post(endpoint, this.payload)
          this.updateActivityLog(endpoint, this.payload, resp, 'POST', resp.id)
          this.showMessage(['success', 'List successfully created'])
        }
        this.$emit('updated')
        this.openAddItemToListDialog = false
        this.handleCloseDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: `Inventory list ${this.parentId ? 'updated' : 'created'}`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>

<style scoped>

</style>